var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 15.1673V39.6673C9.33594 43.5333 12.4699 46.6673 16.3359 46.6673H42.0026C44.5799 46.6673 46.6693 44.578 46.6693 42.0006V25.6673C46.6693 23.09 44.5799 21.0007 42.0026 21.0007H37.3359M9.33594 15.1673C9.33594 18.389 11.9476 21.0007 15.1693 21.0007H37.3359M9.33594 15.1673C9.33594 11.9457 11.9476 9.33398 15.1693 9.33398H34.0418C35.8611 9.33398 37.3359 10.8088 37.3359 12.6281V21.0007",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1667 35.4222C37.0445 35.4222 37.7562 34.7106 37.7562 33.8327C37.7562 32.9548 37.0445 32.2431 36.1667 32.2431C35.2888 32.2431 34.5771 32.9548 34.5771 33.8327C34.5771 34.7106 35.2888 35.4222 36.1667 35.4222Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.845745
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.8713ffa1.svg";
export { ForwardRef as ReactComponent };